import Vue from 'vue'

Vue.filter('uppercase', (val) => val.toUpperCase())

Vue.filter('lowercase', (val) => val.toLowerCase())

Vue.filter('capitalize', (val) => {
  const value = val.toLowerCase()

  return value.replace(/\b\w/g, l => l.toUpperCase())
})

Vue.filter('onlyNumbers', (val) => val.replace(/[^0-9.]/g, ''))

Vue.filter('dateENtoBR', (val) => {
  if (!val) return ''

  const [y, m, d] = val.split('-')
  return `${d}/${m}/${y}`
})

Vue.filter('dateTimeBR', (val) => {
  if (!val) return ''

  const date = new Date(val)

  return date.toLocaleString('pt-BR')
})

Vue.filter('cpf_cnpj', (val) => {
  if (!val) return ''

  const CLEAN_VAL = val.replace(/[^0-9.]/g, '')

  return CLEAN_VAL.length === 11
    ? CLEAN_VAL.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
    : CLEAN_VAL.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
})

Vue.filter('currencyBRL', (val) => {
  if (!val) return ''

  const number = Number(val.toString().replace('R$', '').replace(',', '.').trim())
  const formatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    prefix: 'R$ '
  })

  return formatter.format(number)
})

Vue.filter('smallPreffixCurrencyBRL', (val) => {
  if (!val) return ''
  if (val === '-') return val

  const [value, cents] = val.toString().split('.')

  const formatter = new Intl.NumberFormat('pt-BR', {
    currency: 'BRL',
    style: 'decimal'
  })

  return `
    <small>R$</small> ${formatter.format(parseInt(value))}<small>,${
    cents.length < 2 ? cents + '0' : cents
  }</small>
  `
})

Vue.filter('phone', (val) => {
  if (!val) return ''

  const regex =
    val.length === 11 ? /(\d{2})(\d{5})(\d{4})/ : /(\d{2})(\d{4})(\d{4})/

  return val.replace(regex, '($1) $2-$3')
})

Vue.filter('cep', (val) => {
  if (!val) return ''

  return val.replace(/(\d{5})(\d{3})/, '$1-$2')
})
